import styled from 'styled-components';

export const StyledEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.m}px;
  padding: ${({ theme }) => theme.spacing.xxl}px;
  text-align: center;
`;

/*
 * Empty states sit inside 1080px content columns, where an unconstrained description runs
 * past 100 characters a line. Capping the measure is what makes it read as a sentence
 * rather than a banner.
 */
export const StyledDescription = styled.div`
  max-width: 46ch;
`;
